<template>
  <!-- derived var list -->
  <fragment>
    <div
      class="variable-picker__section mb-3"
      v-if="isMembershipSectionVisible"
    >
      <b-row class="py-1">
        <b-col>
          <b-form-checkbox
            v-model="membershipType.selected"
            class="v2_control_checkbox_small"
            :disabledOld="isOnDashboardOnlySelectable"
          >
            {{ membershipType.label }}
          </b-form-checkbox>
        </b-col>
      </b-row>
    </div>
    <div class="variable-picker__section mb-3" v-if="isProfileSectionVisible">
      
      <div class="profile-derived-variables">
        <div
          class="variable-picker__section-header v2_color_black v2_font_size_18 v2_font_weight_semibold"
          v-if="derivedVariables.length > 0"
        >
          Profile
        </div>

        <div class="checkbox-selection-btn-group">
          <div class="btn-select-all">
            <b-button
              variant="v2_primary"
              class=""
              size="sm"
              @click="selectAll"
            >
              Select All
            </b-button>
          </div>
          <div class="">
            <b-button
              variant="v2_primary"
              class=""
              size="sm"
              @click="clearAll"
            >
              Clear
            </b-button>
          </div>
        </div>
        
      </div>



      <div v-for="dvm in derivedVariables" :key="dvm.derivedVariable.name">
        <!-- temporarily hidden COM-715 -->
        <template v-if="dvm.derivedVariable.name !== 'userZipcode'">
          <b-row class="py-1">
            <b-col>
              <b-form-checkbox
                v-model="dvm.selected"
                class="v2_control_checkbox_small"
                :disabledOld="isOnDashboardOnlySelectable"
              >
                {{ dvm.derivedVariable.title }}
              </b-form-checkbox>
            </b-col>
          </b-row>
        </template>
      </div>
    </div>

    <!-- question variable list -->

    <div
      v-for="sm in availableSections"
      :key="sm.section.id"
      class="variable-picker__section mb-3"
    >

      <div class="section-derived-variables">
        <div
          class="variable-picker__section-header v2_color_black v2_font_size_18 v2_font_weight_semibold"
        >
          {{ sm.section.title }}
        </div>

        <div class="checkbox-selection-btn-group">
          <div class="btn-select-all">
            <b-button
              variant="v2_primary"
              class=""
              size="sm"
              @click="selecOthertAll(sm.section.id)"
            >
              Select All
            </b-button>
          </div>
          <div class="">
            <b-button
              variant="v2_primary"
              class=""
              size="sm"
              @click="clearOtherAll(sm.section.id)"
            >
              Clear
            </b-button>
          </div>
        </div>
      </div>

      <div v-for="qm in getAvailableQuestions(sm)" :key="qm.question.id">
        <!-- row to select all vars for question -->
        <b-row class="py-1">
          <b-col>
            <b-form-checkbox
              class="v2_control_checkbox_small"
              v-model="qm.selected"
              :indeterminate="qm.indeterminate"
              :disabledOld="isOnDashboardOnlySelectable && !qm.is_on_dashboard"
              @change="questionToggled(qm, $event)"
            >
              <span :id="`question-toggle-${qm.question.id}`">
                {{ qm.question.label }}
              </span>
              <span
                class="toggle-collapse collapsed"
                v-if="qm.question.variables.length > 1 && withVariables"
                v-b-toggle="`question-toggle-${qm.question.id}`"
              >
                <menu-right-icon />
              </span>
              <b-popover
                :target="`question-toggle-${qm.question.id}`"
                triggers="hover"
                placement="top"
                :content="qm.question.prompt"
                :delay="{ show: 700, hide: 100 }"
              >
              </b-popover>
            </b-form-checkbox>
          </b-col>
        </b-row>

        <!-- rows to select individual vars -->
        <b-collapse
          v-if="withVariables"
          :id="`question-toggle-${qm.question.id}`"
          :visible="false"
        >
          <b-row v-for="vm in qm.variables" :key="vm.variable.id" class="py-1">
            <b-col class="text-right">
              <b-form-checkbox
                class="mt-2 v2_control_checkbox_small"
                v-model="vm.selected"
                :disabledOld="isOnDashboardOnlySelectable && !qm.is_on_dashboard"
                @change="varToggled(qm)"
              >
                {{ vm.variable.input_label }}
              </b-form-checkbox>
            </b-col>
          </b-row>
        </b-collapse>
      </div>
    </div>
  </fragment>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Questionnaire from '@/providers/Questionnaire.js';
import MenuRightIcon from 'vue-material-design-icons/MenuRight';
import cloneDeep from 'lodash/cloneDeep';

export default {
  name: 'ChartsCheckboxes',
  components: {
    MenuRightIcon,
  },
  props: {
    initialDerivedVariables: {
      type: Array,
      required: true,
    },
    initialSections: {
      type: Array,
      required: true,
    },
    initialMembershipType: {
      type: Object,
    },
    withVariables: {
      type: Boolean,
      default: false,
    },
    isProfileSectionVisible: {
      type: Boolean,
      default: true,
    },
    isMembershipSectionVisible: {
      type: Boolean,
      default: false,
    },
    isOnDashboardOnlySelectable: {
      type: Boolean,
      default: false,
    },
    completedModules: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data: function () {
    return {
      derivedVariables: cloneDeep(this.initialDerivedVariables),
      sections: cloneDeep(this.initialSections),
      membershipType: this.initialMembershipType,
    };
  },
  computed: {
    isEmpty: function () {
      return this.derivedVariables.length === 0 && this.sections.length === 0;
    },
    visibleSections: function () {
      return this.sections.filter(({ section }) => {
        return (
          !section.is_module ||
          (section.is_module && this.isCompletedModule(section.id))
        );
      });
    },
    availableSections: function () {
      return this.withVariables
        ? this.visibleSections
        : this.visibleSections.filter((sm) =>
            sm.questions.some((question) => question.is_available_on_results)
          );
    },
  },
  methods: {
    isCompletedModule: function (moduleId) {
      return !!this.completedModules.find((m) => m.id === moduleId);
    },
    getSelected: function () {
      const derivedVarNames = this.derivedVariables.reduce((acc, dvm) => {
        if (dvm.selected) acc.push(dvm.derivedVariable.name);
        return acc;
      }, []);
      const [questionIds, variableIds] = this.sections.reduce(
        ([qIds, vIds], section) => {
          section.questions.forEach((qm) => {
            let selectQuestion = false;
            qm.variables.forEach((vm) => {
              if (vm.selected) {
                vIds.push(vm.variable.id);
                selectQuestion = true;
              }
            });
            if (selectQuestion || qm.selected) {
              qIds.push(qm.question.id);
            }
          });
          return [qIds, vIds];
        },
        [[], []]
      );
      const membershipType = this.membershipType.selected;
      return {
        derivedVarNames,
        questionIds,
        variableIds,
        membershipType,
      };
    },
    questionToggled: function (qm, checked) {
      // select/deselect all variables
      qm.variables.forEach((vm) => {
        vm.selected = checked;
      });
    },
    varToggled: function (qm) {
      this.$nextTick(() =>
        this.$set(qm, 'indeterminate', Questionnaire.isIndeterminate(qm))
      );
    },
    updateSelectStatus: function (status) {
      this.derivedVariables = this.derivedVariables.filter(item => item.derivedVariable.name !== 'userZipcode');
      this.derivedVariables.forEach((dvm) => (dvm.selected = status));
      /* 
      Before select/clear all filter this commented line of code is working. 
      Now I comment this code and add to select all 
      
      */
      // this.sections.forEach((section) => {
      //   section.questions.forEach((qm) => {
      //     if (qm.is_available_on_results || status === false) {
      //       qm.variables.forEach((vm) => (vm.selected = status));
      //       qm.selected = status;
      //     }
      //   });
      // });
      if (this.isMembershipSectionVisible) {
        this.membershipType.selected = status;
      }
    },
    updateSelectOtherStatus: function (status,sectionId) {
      this.sections.forEach((section) => {
        if(sectionId == section.section.id)
        {
          section.questions.forEach((qm) => {
            if (qm.is_available_on_results || status === false) {
              qm.variables.forEach((vm) => (vm.selected = status));
              qm.selected = status;
            }
          });
        }
      });
      if (this.isMembershipSectionVisible) {
        this.membershipType.selected = status;
      }
    },
    clearAll: function () {
      this.updateSelectStatus(false);
    },
    selectAll: function () {
      this.updateSelectStatus(true);
    },
    selecOthertAll: function (sectionId) {
      this.updateSelectOtherStatus(true,sectionId);
    },
    clearOtherAll: function (sectionId) {
      this.updateSelectOtherStatus(false,sectionId);
    },
    getAvailableQuestions: function (section) {
      return section.questions.filter(
        (qs) => this.withVariables || !!qs.is_available_on_results
      );
    },
  },
};
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">
// include this in any Vue component where you want to reference vars or mixins
@import '../../../../sass/variables_mixins';

.variable-picker__question-id {
  position: absolute;
  top: 10px;
  right: 50px;
  color: #bbb;
  font-size: 80%;
}

.variable-picker__question-label {
  @include phairify_body_copy;
  color: $phairify_primary_color_navy;
  //padding-left: 25px;
}

.variable-picker__variable-label {
  display: inline-block;
  text-indent: -15px;
  @include phairify_body_copy;
  color: $phairify_primary_color_navy;
}

span.toggle-collapse {
  display: inline-block;
  position: relative;
  width: 15px;
  .material-design-icon {
    position: absolute;
    height: 36px;
    width: 36px;
    bottom: -12px;
    left: -10px;
    &:hover {
      cursor: pointer;
    }
  }

  .material-design-icon > .material-design-icon__svg {
    height: 36px;
    width: 36px;
    fill: $phairify_primary_color_icon;
  }
  svg {
    @include transform(rotate(90deg));
    @include transition(all 0.2s ease-in-out);
  }
}

span.toggle-collapse.collapsed {
  svg {
    @include transform(rotate(0deg));
  }
}

.profile-derived-variables, .section-derived-variables{
  display: flex;
  align-items: center;
  justify-content:space-between;
}
.btn-select-all{
  margin:0px 5px; 
}
.checkbox-selection-btn-group{
  display:flex;
  align-items:center;
}

@media screen and (min-width: 600px) and (orientation: portrait) {
  .checkbox-selection-btn-group .btn-v2_primary {
    min-width: unset !important;
  }
}
</style>
